import type {ValueOf} from '~/types/value-of'

const rootPath = '/blocks'

export const blockDetailPageType = {
  block: 'block',
  transactions: 'transactions',
  internalTransactions: 'internal-transactions'
} as const
export type blockDetailPageType = ValueOf<typeof blockDetailPageType>;

export default {
  getBlockListPage() {
    return rootPath
  },
  getBlockDetailPageWithTab(blockNumber: string, tab?: blockDetailPageType) {
    if (!tab) tab = blockDetailPageType.block
    return this.getBlockListPage() + `/${blockNumber}` + `/${tab}`
  },
  isBlockPage(path: string) {
    const regs = [/^\/blocks\/([^/]+?)\/block\/?$/i, /^\/blocks\/([^/]+?)\/internal-transactions\/?$/i, /^\/blocks\/([^/]+?)\/transactions\/?$/i]
    const res = regs.find(reg => path.match(reg))
    return !!res
  }
}